// Событие для уведомления о необходимости показать диалог истекшего сеанса
export const SESSION_EXPIRED_EVENT = 'session-expired';

// Функция для показа диалога истекшего сеанса
export const showSessionExpiredDialog = () => {
  // Диспатчим событие, которое будет обработано в компоненте
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
};
